import React, { useState } from 'react';
import api from '../utils/api';

const fields = [
  ['org_name', 'Organization name', 'text', 150],
  ['contact_first_name', 'Contact first name', 'text', 100],
  ['contact_last_name', 'Contact last name', 'text', 100],
  ['contact_position', 'Position', 'text', 100],
  ['contact_email', 'Email', 'email', 150],
  ['contact_phone', 'Phone', 'tel', 30],
  ['website', 'Website', 'text', 500],
  ['address', 'Street address', 'text', 500],
  ['city', 'City', 'text', 100],
  ['province', 'Province', 'text', 100],
  ['postal_code', 'Postal code', 'text', 20],
];

export default function HostContactEditor({ host, onSaved }) {
  const [editing, setEditing] = useState(false);
  const [form, setForm] = useState({});
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const start = () => {
    const legacy = (host.contact_name || '').trim().split(/\s+/);
    const initial = Object.fromEntries(fields.map(([key]) => [key, host[key] || '']));
    if (!initial.contact_first_name && !initial.contact_last_name && host.contact_name) {
      initial.contact_first_name = legacy[0];
      initial.contact_last_name = legacy.slice(1).join(' ');
    }
    setForm(initial); setError(''); setSuccess(''); setEditing(true);
  };
  const save = async e => {
    e.preventDefault();
    setBusy(true); setError('');
    try {
      await api.patch(`/hosts/${host.id}/contact`, form);
      setEditing(false);
      setSuccess('Contact details saved.');
      onSaved();
    } catch (err) {
      setError(err.response?.data?.error || 'Could not save contact details.');
    } finally { setBusy(false); }
  };
  if (!editing) return (
    <div style={{ marginTop: 12 }}>
      <button className="dp-btn" onClick={start}>Edit contact details</button>
      {success && <p role="status" style={{ fontSize: 13 }}>{success}</p>}
    </div>
  );
  return (
    <form onSubmit={save} style={{ marginTop: 16 }}>
      <p style={{ fontSize: 13 }}>Update details after speaking with the host. Agreements, programs
        and placement availability won’t change. Clear an optional field to remove its old value.</p>
      {error && <p role="alert" style={{ color: '#b42318' }}>{error}</p>}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2,minmax(0,1fr))', gap: 12 }}>
        {fields.map(([key, label, type, maxLength]) => (
          <label key={key} style={{ fontSize: 12, gridColumn: ['org_name', 'website', 'address'].includes(key) ? '1 / -1' : undefined }}>
            {label}
            <input className="input" style={{ width: '100%', marginTop: 4 }} value={form[key]}
              type={type} maxLength={maxLength} required={key === 'org_name'} disabled={busy}
              placeholder={key === 'website' ? 'https://example.ca' : undefined}
              onChange={e => setForm(prev => ({ ...prev, [key]: e.target.value }))} />
          </label>
        ))}
      </div>
      <div style={{ display: 'flex', gap: 10, marginTop: 14 }}>
        <button type="submit" className="dp-btn primary" disabled={busy}>{busy ? 'Saving…' : 'Save details'}</button>
        <button type="button" className="dp-btn" disabled={busy}
          onClick={() => { setEditing(false); setError(''); }}>Cancel</button>
      </div>
    </form>
  );
}
